import React, { PureComponent } from "react";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "./../Utils/Utils.js";

class WorldCupInstagramTopStories extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { title, url } = this.props;

    data = data.map((e, idx) => {
      return {
        ...e,
        id: idx,
        network: "instagram",
      };
    });

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "handle",
        text: "Handle",
        style: { width: "90px", minWidth: "90px", textTransform: "capitalize" },
        sort: true,
      },
      {
        dataField: "reach",
        text: "Reach",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "taps_forward",
        text: "Taps Fwd",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "taps_back",
        text: "Taps Back",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "exits",
        text: "Exits",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 5,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "reach",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={pagination}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default WorldCupInstagramTopStories;
